module.exports = __webpack_public_path__ + "img/Freespin_h4.bedcd3c6.png";